import React from "react";
import { LotteryDetailsPage } from "../../Components/dashboard";

const OrgLotteryDetails = () => {
  return <LotteryDetailsPage role="creator" />;
};

export default OrgLotteryDetails;
